import React from 'react';
import noImage from '../../assets/images/no-image.png';

export default function CommonImage({ productImage }) {
  const handleImageError = (event) => {
    event.target.src = noImage;
  };
  return <img className="logo max-w-h-48" src={productImage || noImage} alt="Company Logo" onError={handleImageError} />;
}
